import { useI18n } from '@app-velocity/i18n';
import { RemoveIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';
import { Button } from '@app-velocity/ui';

const messageBus = new MessageBus('prototypes');

export type RemoveFigmaReportButtonProps = {
  id: string;
};

export const RemoveFigmaReportButton = ({
  id,
}: RemoveFigmaReportButtonProps) => {
  const { t } = useI18n();

  const onClick = () => {
    messageBus.publish('modal:delete-figma-report:open', { id });
  };

  return (
    <Button variant="reportAction" color="error" onClick={onClick}>
      <RemoveIcon />
      {t('shared:delete')}
    </Button>
  );
};
